module.exports = __webpack_public_path__ + "static/img/03-2.ca41f31a.png";